export default "__VITE_ASSET__BfmbwpDV__"